module.exports = __webpack_public_path__ + "img/xnzhzxxxhpt.ac5d7a71.png";